import { Action } from '@ngrx/store';
import { AccountLimits } from 'app/account/account.model';

export const GET_LIMITS = 'GET_LIMITS';
export const GET_LIMITS_SUCCESS = 'GET_LIMITS_SUCCESS';

export class GetLimitsAction implements Action {
  readonly type = GET_LIMITS;

  constructor() {}
}

export class GetLimitsSuccessAction implements Action {
  readonly type = GET_LIMITS_SUCCESS;

  constructor(public payload: AccountLimits) {}
}

export type LimitsActions = GetLimitsAction | GetLimitsSuccessAction;
